module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fieldset"
  }, [_vm._l((_vm.fields), function(field) {
    return (!_vm.customLayout) ? _c('formly-field', {
      key: 'formly_' + field.key,
      ref: field.key,
      refInFor: true,
      attrs: {
        "form": _vm.form,
        "model": _vm.model,
        "field": field
      },
      on: {
        "update:form": function($event) {
          _vm.form = $event
        },
        "update:model": function($event) {
          _vm.model = $event
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._t("default", null, {
    keys: _vm.keys
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6c53466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/FormlyFormFlex.vue
// module id = 1116
// module chunks = 0